/**
 * Sticky add-to-cart bar for the migrated landing pages: reveal + stepper.
 *
 * The markup wears biosphere-sticky-atc's classes and stylesheet, but not its script —
 * that one submits a product form by id, and these sections have no form. The section
 * owns the add-to-cart; only these two behaviours were missing.
 *
 * Reveal uses an IntersectionObserver on the real add-to-cart row rather than live's
 * scroll handler. Presence is the `hidden` attribute, as in the component.
 *
 * Loaded only by sections/magnesium-product-detail.liquid.
 */
(function () {
  var bar = document.querySelector(".pro_sticky_bar");
  if (!bar) return;

  /* ── Reveal ──
     The watched element is the section's real add-to-cart row, the
     counterpart of the wrapper live watches. Looked up by its own class
     rather than anything inside the bar: the bar used to carry the same
     hook class, and watching itself would never resolve. */
  var watched = document.querySelector(".mpd__atc-row");

  if (watched && "IntersectionObserver" in window) {
    new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          bar.toggleAttribute("hidden", entry.isIntersecting);
        });
      },
      /* Any sliver of the real button counts as visible, matching live's
         overlap test rather than a midpoint. */
      { threshold: 0 }
    ).observe(watched);
  }
  /* No observer support, or nothing to watch: the bar stays hidden. The
     page's own add-to-cart is untouched, which is the baseline that has
     to hold. */

  /* ── Stepper ──
     Two things hold the quantity: the figure the buyer reads, and the
     hidden field the section's script posts. They are stepped together so
     neither can drift from the other. */
  var input = bar.querySelector('input[name="quantity"]');
  var count = bar.querySelector("[data-sticky-quantity]");
  if (!input || !count) return;

  bar.querySelectorAll("[data-step]").forEach(function (button) {
    button.addEventListener("click", function () {
      var step = parseInt(button.dataset.step, 10) || 0;
      var current = parseInt(input.value, 10) || 1;
      var next = Math.max(1, current + step);

      if (next === current) return;

      input.value = next;
      count.textContent = next;

      /* The section's script reads the field on submit rather than
         listening, but firing the event keeps it honest for anything else
         bound to it. */
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  });
})();
